import { useEffect, useMemo, useState } from "react";
import { Select } from "@mantine/core";
import { getVariantGroupOptions } from "../../../api";

export default function VariantGroupInput({ form, attrib, product, value, error }) {
  const [options, setOptions] = useState([]);
  const stringValue =
    value === null || value === undefined ? "" : String(value);

  useEffect(() => {
    if (!product?.id) return undefined;
    let cancelled = false;
    getVariantGroupOptions(product.id)
      .then((data) => {
        if (!cancelled) setOptions(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (!cancelled) setOptions([]);
      });
    return () => {
      cancelled = true;
    };
  }, [product?.id]);

  const data = useMemo(() => {
    const items = [];
    const seen = new Set();
    for (const o of options) {
      const sku = String(o?.sku ?? o?.Sku ?? "").trim();
      if (!sku || seen.has(sku.toLowerCase())) continue;
      seen.add(sku.toLowerCase());
      const isCurrent = o.isCurrent ?? o.IsCurrent;
      const name = o.name ?? o.Name;
      items.push({
        value: sku,
        label: isCurrent
          ? `${sku} (this listing)`
          : name
            ? `${sku} — ${name}`
            : sku,
      });
    }
    if (stringValue && !items.some((item) => item.value === stringValue)) {
      items.unshift({ value: stringValue, label: stringValue });
    }
    return items;
  }, [options, stringValue]);

  return (
    <Select
      searchable
      clearable
      allowDeselect
      placeholder="Standalone — this listing"
      nothingFoundMessage="No matching SKUs"
      data={data}
      value={stringValue || null}
      onChange={(val) => form.setFieldValue(attrib.code, val ?? "")}
      error={error}
    />
  );
}
